import { Button } from "@/components/ui/button";
import { Download, Eye, Loader2, Trash2 } from "lucide-react";

interface SentDocumentFieldProps {
  fileName: string;
  onView: () => void;
  onDownload: () => void;
  onDelete: () => void;
  isViewLoading?: boolean;
  isDownloadLoading?: boolean;
  isDeleting?: boolean;
}

const truncateFileName = (name: string, maxLength: number = 30) => {
  if (name.length <= maxLength) return name;

  const extension = name.split('.').pop();
  const nameWithoutExt = name.substring(0, name.lastIndexOf('.'));
  const truncatedName = nameWithoutExt.substring(0, maxLength - extension!.length - 4);

  return `${truncatedName}...${extension}`;
};

export function SentDocumentField({
  fileName,
  onView,
  onDownload,
  onDelete,
  isViewLoading,
  isDownloadLoading,
  isDeleting,
}: SentDocumentFieldProps) {
  return (
    <div className="border border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-950/40 rounded-md p-3">
      <div className="flex flex-col items-center justify-center w-full h-28 border-2 border-dashed rounded-lg bg-green-50 border-green-300 dark:bg-green-950/30 dark:border-green-700 px-2 py-4">
        <svg
          className="w-6 h-6 mb-2 text-green-500 dark:text-green-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        <p className="mb-2 text-xs text-green-600 dark:text-green-400 text-center max-w-full">
          <span className="font-semibold break-words" title={fileName}>
            {fileName ? truncateFileName(fileName) : "Documento já enviado"}
          </span>
        </p>
        <div className="flex flex-wrap items-center justify-center gap-1.5">
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-7 px-2 text-xs"
            onClick={onView}
            disabled={isViewLoading}
          >
            {isViewLoading ? (
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
            ) : (
              <Eye className="h-3.5 w-3.5" />
            )}
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-7 px-2 text-xs"
            onClick={onDownload}
            disabled={isDownloadLoading}
          >
            {isDownloadLoading ? (
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
            ) : (
              <Download className="h-3.5 w-3.5" />
            )}
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-7 px-2 text-xs text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700"
            onClick={onDelete}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
            ) : (
              <Trash2 className="h-3.5 w-3.5" />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
